export default __webpack_public_path__ + "static/media/ic_my-approvals.80a79b3e.svg";